import script from "./LocalResolver.vue?vue&type=script&lang=js"
export * from "./LocalResolver.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__